import { render, staticRenderFns } from "./editImage.vue?vue&type=template&id=59246568&scoped=true"
import script from "./editImage.vue?vue&type=script&lang=js"
export * from "./editImage.vue?vue&type=script&lang=js"
import style0 from "./editImage.vue?vue&type=style&index=0&id=59246568&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59246568",
  null
  
)

export default component.exports